function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 16,
  fill: "color(display-p3 .922 1 .91)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.395 13.451a.6.6 0 10-.79-.902l-7.578 6.63-3.603-3.603a.6.6 0 00-.848.848l4 4a.6.6 0 00.82.027l8-7z",
  fill: "color(display-p3 0 .5716 .5373)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 29c7.18 0 13-5.82 13-13S23.18 3 16 3 3 8.82 3 16s5.82 13 13 13zm11.8-13c0 6.517-5.283 11.8-11.8 11.8S4.2 22.517 4.2 16 9.483 4.2 16 4.2 27.8 9.483 27.8 16z",
  fill: "color(display-p3 0 .5716 .5373)"
});

function SvgTodoOffHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iMTYiIGZpbGw9IiNFQkZGRTgiIHN0eWxlPSJmaWxsOiNFQkZGRTg7ZmlsbDpjb2xvcihkaXNwbGF5LXAzIDAuOTIyMCAxLjAwMDAgMC45MTAwKTtmaWxsLW9wYWNpdHk6MTsiLz4KPHBhdGggZD0iTTIyLjM5NTEgMTMuNDUxNUMyMi42NDQ1IDEzLjIzMzMgMjIuNjY5OCAxMi44NTQzIDIyLjQ1MTUgMTIuNjA0OUMyMi4yMzMzIDEyLjM1NTUgMjEuODU0MyAxMi4zMzAyIDIxLjYwNDkgMTIuNTQ4NUwxNC4wMjczIDE5LjE3ODhMMTAuNDI0MyAxNS41NzU3QzEwLjE4OTkgMTUuMzQxNCA5LjgxMDA1IDE1LjM0MTQgOS41NzU3NCAxNS41NzU3QzkuMzQxNDIgMTUuODEwMSA5LjM0MTQyIDE2LjE4OTkgOS41NzU3NCAxNi40MjQzTDEzLjU3NTcgMjAuNDI0M0MxMy43OTkxIDIwLjY0NzYgMTQuMTU3NCAyMC42NTk2IDE0LjM5NTEgMjAuNDUxNUwyMi4zOTUxIDEzLjQ1MTVaIiBmaWxsPSIjMDA5Mjg5IiBzdHlsZT0iZmlsbDojMDA5Mjg5O2ZpbGw6Y29sb3IoZGlzcGxheS1wMyAwLjAwMDAgMC41NzE2IDAuNTM3Myk7ZmlsbC1vcGFjaXR5OjE7Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTYgMjlDMjMuMTc5NyAyOSAyOSAyMy4xNzk3IDI5IDE2QzI5IDguODIwMyAyMy4xNzk3IDMgMTYgM0M4LjgyMDMgMyAzIDguODIwMyAzIDE2QzMgMjMuMTc5NyA4LjgyMDMgMjkgMTYgMjlaTTI3LjggMTZDMjcuOCAyMi41MTcgMjIuNTE3IDI3LjggMTYgMjcuOEM5LjQ4MzA0IDI3LjggNC4yIDIyLjUxNyA0LjIgMTZDNC4yIDkuNDgzMDQgOS40ODMwNCA0LjIgMTYgNC4yQzIyLjUxNyA0LjIgMjcuOCA5LjQ4MzA0IDI3LjggMTZaIiBmaWxsPSIjMDA5Mjg5IiBzdHlsZT0iZmlsbDojMDA5Mjg5O2ZpbGw6Y29sb3IoZGlzcGxheS1wMyAwLjAwMDAgMC41NzE2IDAuNTM3Myk7ZmlsbC1vcGFjaXR5OjE7Ii8+Cjwvc3ZnPgo=";
export { SvgTodoOffHover as ReactComponent };